'use client';

import { useSuspenseQuery } from '@tanstack/react-query';
import Link from 'next/link';
import WideLogo from 'public/wide-logo.png';
import { memo } from 'react';

import CommonLanguageSelector from '@/components/common/LanguageSelector';
import { cn } from '@/lib/utils';

import { productOptions } from '../options/product';
import { productCodeOptions } from '../options/product_code';

interface IProps {
  idx?: string;
  code?: string;
  lng?: string;
}
function ProductBanner({ idx, code, lng }: IProps) {
  const { data: product } = useSuspenseQuery(
    idx ? productOptions({ idx, lng }) : productCodeOptions({ productCode: code || '', lng }),
  );

  return (
    <header id='banner' className={cn('relative w-full border-b border-[#E9ECEF]')}>
      <div className='relative z-10 mx-auto flex w-full max-w-7xl items-center justify-between gap-2 px-5 py-1'>
        <Link href='/'>
          <img
            src={product.productMerchant?.logoImage?.url || WideLogo.src}
            alt='Wonder Round'
            className='h-auto max-h-20 w-full min-w-28 max-w-44 opacity-90'
          />
        </Link>

        <CommonLanguageSelector isBanner />
      </div>
    </header>
  );
}

export default memo(ProductBanner);
